// Centralised bilingual content for Sukhakarta Patsanstha
export const t = {
    org: {
        nameFull: { en: "Sukhakarta Nagari Sahakari Patsanstha Maryadit", mr: "सुखकर्ता नागरी सहकारी पतपेढी मर्यादित" },
        nameShort: { en: "Sukhakarta Patsanstha", mr: "सुखकर्ता पतपेढी" },
        regNo: { en: "Reg. No: T.N.A./R.S.R.(C.R.) 840/96-97", mr: "नोंदणी क्र.: T.N.A./R.S.R.(C.R.) 840/96-97" },
        tagline: {
            en: "Your Trusted Partner for Financial Growth and Security",
            mr: "तुमच्या स्वप्नांना आर्थिक बळ देणारी विश्वासाची पतपेढी"
        }
    },

    nav: {
        home: { en: "Home", mr: "मुख्यपृष्ठ" },
        about: { en: "About Us", mr: "आमच्याविषयी" },
        certificate: { en: "Certificate", mr: "प्रमाणपत्र" },
        documents: { en: "Documents", mr: "कागदपत्रे" },
        deposits: { en: "Deposit Schemes", mr: "ठेवी योजना" },
        loans: { en: "Loan Schemes", mr: "कर्ज योजना" },
        calculator: { en: "Interest Calculator", mr: "व्याज कॅल्क्युलेटर" },
        contact: { en: "Contact Us", mr: "संपर्क" },
        membership: { en: "Become a Member", mr: "सभासद नोंदणी" }
    },

    cta: {
        contactUs: { en: "Contact Us", mr: "आमच्याशी संपर्क करा" },
        applyLoan: { en: "Apply for Loan", mr: "कर्जासाठी अर्ज करा" },
        joinMember: { en: "Become a Member", mr: "सभासद व्हा" },
        learnMore: { en: "Learn More", mr: "अधिक माहिती" },
        calculate: { en: "Calculate", mr: "गणना करा" },
        submit: { en: "Submit", mr: "पाठवा" },
        sending: { en: "Sending…", mr: "पाठवत आहे…" },
        whatsapp: { en: "Chat on WhatsApp", mr: "व्हॉट्सअ‍ॅप वर संपर्क" }
    },

    hours: {
        title: { en: "Office Hours", mr: "कार्यालयीन वेळा" },
        weekdays: { en: "Mon – Sat: 10:00 AM to 6:00 PM", mr: "सोमवार – शनिवार: सकाळी १०:०० ते सायं. ६:००" },
        lunch: { en: "Lunch Break: 1:30 PM to 2:15 PM", mr: "जेवण सुट्टी: दु. १:३० ते २:१५" },
        sunday: { en: "Sunday: Closed", mr: "रविवार: सुट्टी" }
    },

    home: {
        statYears: { en: "Years of Trust", mr: "वर्षांचा विश्वास" },
        statMembers: { en: "Happy Members", mr: "समाधानी सभासद" },
        statSchemes: { en: "Loan Schemes", mr: "कर्ज योजना" },
        statDeposit: { en: "Deposit Schemes", mr: "ठेवी योजना" },

        servicesTitle: { en: "Our Services", mr: "आमच्या सेवा" },
        servicesSub: { en: "Comprehensive financial solutions for every milestone of your life", mr: "तुमच्या आयुष्यातील प्रत्येक टप्प्यासाठी संपूर्ण आर्थिक उपाय" },

        whyTitle: { en: "Why Choose Us", mr: "आम्हाला का निवडावे?" },
        whySub: { en: "Three decades of trust, transparency and member-first banking", mr: "तीन दशकांचा विश्वास, पारदर्शकता आणि सभासद-केंद्रित सेवा" },

        testimonialsTitle: { en: "What Our Members Say", mr: "आमचे सभासद काय म्हणतात" }
    },

    about: {
        title: { en: "About Us", mr: "आमच्याविषयी" },
        intro: {
            en: "Sukhakarta Nagari Sahakari Patsanstha Maryadit is a trusted, member-centric financial institution serving common citizens, businesspersons, entrepreneurs, women, youth, and senior citizens. Our goal is to safeguard members' savings and provide timely financial assistance.",
            mr: "सुखकर्ता नागरी सहकारी पतपेढी मर्यादित ही सर्वसामान्य नागरिक, व्यावसायिक, उद्योजक, महिला, युवक आणि ज्येष्ठ नागरिक यांच्यासाठी कार्यरत असलेली विश्वासार्ह व सभासद-केंद्रित संस्था आहे. सभासदांच्या बचतीचे संरक्षण करणे आणि वेळेवर आर्थिक मदत पुरवणे हे आमचे ध्येय आहे."
        },
        mission: { en: "Mission", mr: "ध्येय" },
        missionText: {
            en: "To provide transparent, trustworthy, and fast financial services for members' economic growth.",
            mr: "सभासदांच्या आर्थिक प्रगतीसाठी पारदर्शक, विश्वासार्ह आणि जलद आर्थिक सेवा पुरवणे."
        },
        vision: { en: "Vision", mr: "दूरदृष्टी" },
        visionText: {
            en: "To become the most trusted and advanced cooperative financial institution in the region using modern technology.",
            mr: "आधुनिक तंत्रज्ञानाच्या साहाय्याने प्रदेशातील सर्वात विश्वासार्ह व प्रगत सहकारी आर्थिक संस्था बनणे."
        },
        featuresTitle: { en: "Key Features", mr: "ठळक वैशिष्ट्ये" },
        features: [
            { en: "Safe and attractive deposit schemes", mr: "सुरक्षित व आकर्षक ठेवी योजना" },
            { en: "Fast and easy loan processing", mr: "जलद व सोपी कर्ज प्रक्रिया" },
            { en: "Experienced and trained staff", mr: "अनुभवी व प्रशिक्षित कर्मचारी" },
            { en: "Member-centric services", mr: "सभासद-केंद्रित सेवा" },
            { en: "Transparent transaction system", mr: "पारदर्शक व्यवहार प्रणाली" },
            { en: "Financial planning guidance", mr: "आर्थिक नियोजन मार्गदर्शन" }
        ],
        boardTitle: { en: "Board of Members", mr: "संचालक मंडळ" },
        boardSubtitle: {
            en: "Meet the dedicated members steering our society forward.",
            mr: "आमच्या संस्थेचे नेतृत्व करणारे समर्पित संचालक मंडळ सदस्य."
        },
        achievementsTitle: { en: "Our Achievements", mr: "आमची यशोगाथा" },
        achievementsSubtitle: {
            en: "Milestones and recognitions earned through years of trusted service.",
            mr: "विश्वासार्ह सेवेतून मिळालेले टप्पे आणि सन्मान."
        }
    },

    certificate: {
        title: { en: "Certificates", mr: "प्रमाणपत्रे" },
        subtitle: {
            en: "Official registration and statutory certificates of our society.",
            mr: "आमच्या संस्थेची अधिकृत नोंदणी व वैधानिक प्रमाणपत्रे."
        },
        registration: { en: "Registration Certificate", mr: "नोंदणी प्रमाणपत्र" },
        others: { en: "Other Certificates", mr: "इतर प्रमाणपत्रे" }
    },

    deposits: {
        title: { en: "Deposit Schemes", mr: "ठेवी योजना" },
        subtitle: { en: "Grow your savings with attractive interest rates and flexible tenures.", mr: "आकर्षक व्याजदर आणि लवचिक मुदतीसह आपली बचत वाढवा." },
        tabs: {
            fd: { en: "Fixed Deposit", mr: "मुदत ठेव" },
            fdSenior: { en: "FD (Senior)", mr: "मुदत ठेव (ज्येष्ठ)" },
            mip: { en: "Monthly Income", mr: "मासिक उत्पन्न" },
            mipSenior: { en: "MIP (Senior)", mr: "मासिक उत्पन्न (ज्येष्ठ)" },
            rd: { en: "Recurring Deposit", mr: "आवर्ती ठेव" },
            special: { en: "Special Schemes", mr: "विशेष योजना" }
        }
    },

    loans: {
        title: { en: "Loan Schemes", mr: "कर्ज योजना" },
        subtitle: { en: "Fast, flexible loans tailored to your needs — from personal to business.", mr: "तुमच्या गरजेनुसार वैयक्तिक ते व्यावसायिक — जलद व लवचिक कर्ज." },
        items: [
            { key: "personal", en: "Personal Loan", mr: "वैयक्तिक कर्ज", icon: "fa-user-shield", desc: { en: "For weddings, medical needs, travel and personal goals.", mr: "विवाह, वैद्यकीय, प्रवास व वैयक्तिक गरजांसाठी." } },
            { key: "business", en: "Business Loan", mr: "व्यवसाय कर्ज", icon: "fa-briefcase", desc: { en: "Working capital and expansion finance for entrepreneurs.", mr: "उद्योजकांसाठी खेळते भांडवल व विस्तारासाठी कर्ज." } },
            { key: "home", en: "Home / Property Loan", mr: "गृहतारण कर्ज", icon: "fa-house-chimney", desc: { en: "Buy, build or renovate your dream home.", mr: "स्वप्नातील घर खरेदी, बांधकाम वा नूतनीकरणासाठी." } },
            { key: "deposit", en: "Loan Against Deposit", mr: "ठेव तारण कर्ज", icon: "fa-piggy-bank", desc: { en: "Instant loan against your FD/RD at lowest rates.", mr: "तुमच्या मुदत/आवर्ती ठेवीवर तत्काळ कमी दराने कर्ज." } },
            { key: "gold", en: "Gold Loan", mr: "सोने तारण कर्ज", icon: "fa-coins", desc: { en: "Quick disbursal against gold ornaments with safe custody.", mr: "सोन्याच्या दागिन्यांवर त्वरित कर्ज व सुरक्षित संरक्षण." } },
            { key: "vehicle", en: "Vehicle Loan", mr: "वाहन कर्ज", icon: "fa-car", desc: { en: "Two-wheeler, car, and commercial vehicle finance.", mr: "दुचाकी, चारचाकी व व्यावसायिक वाहनांसाठी कर्ज." } },
            { key: "education", en: "Education Loan", mr: "शैक्षणिक कर्ज", icon: "fa-graduation-cap", desc: { en: "Invest in your child's future with flexible repayment.", mr: "मुलांच्या उज्ज्वल भविष्यासाठी लवचिक परतफेडीसह कर्ज." } }
        ]
    },

    contact: {
        title: { en: "Contact Us", mr: "संपर्क" },
        addressLabel: { en: "Address", mr: "पत्ता" },
        mobileLabel: { en: "Mobile", mr: "मोबाईल" },
        hoursLabel: { en: "Working Hours", mr: "कार्यालयीन वेळा" },
        address: {
            en: "Shop No. 1, Shri Ayyappa Krupa Bungalow, Sector 5, Shreenagar, Wagle Estate, Thane – 400 604.",
            mr: "दुकान क्र. १, श्री अय्यप्पा कृपा बंगला, सेक्टर ५, श्रीनगर, वागळे इस्टेट, ठाणे – ४०० ६०४."
        },
        mobile: "9987070049",
        formTitle: { en: "Send us a message", mr: "आम्हाला संदेश पाठवा" }
    },

    membership: {
        title: { en: "Become a Member", mr: "सभासद नोंदणी" },
        subtitle: { en: "Take the first step toward a secure financial future. Fill the form and our team will reach out.", mr: "सुरक्षित आर्थिक भविष्यासाठी पहिले पाऊल टाका. फॉर्म भरा, आमची टीम तुमच्याशी संपर्क साधेल." }
    },

    calculator: {
        title: { en: "Interest Calculator", mr: "व्याज कॅल्क्युलेटर" },
        subtitle: { en: "Estimate maturity values across FD, RD and MIP schemes instantly.", mr: "एफडी, आरडी आणि एमआयपी योजनांचे परिपक्वता मूल्य त्वरित जाणून घ्या." },
        scheme: { en: "Scheme", mr: "योजना" },
        amount: { en: "Deposit Amount (₹)", mr: "ठेव रक्कम (₹)" },
        monthlyAmount: { en: "Monthly Amount (₹)", mr: "मासिक रक्कम (₹)" },
        tenure: { en: "Tenure", mr: "मुदत" },
        senior: { en: "Senior Citizen (Above 60)", mr: "ज्येष्ठ नागरिक (६० वर्षांवरील)" },
        result: { en: "Maturity Value", mr: "परिपक्वता रक्कम" },
        monthlyIncome: { en: "Monthly Income", mr: "मासिक उत्पन्न" },
        totalInvested: { en: "Total Invested", mr: "एकूण गुंतवणूक" },
        totalInterest: { en: "Interest Earned", mr: "मिळणारे व्याज" },
        rate: { en: "Interest Rate", mr: "व्याजदर" }
    },

    form: {
        name: { en: "Full Name", mr: "पूर्ण नाव" },
        mobile: { en: "Mobile Number", mr: "मोबाईल नंबर" },
        email: { en: "Email", mr: "ईमेल" },
        address: { en: "Address", mr: "पत्ता" },
        queryType: { en: "Query Type", mr: "चौकशी प्रकार" },
        scheme: { en: "Scheme of Interest", mr: "आवडती योजना" },
        message: { en: "Message", mr: "संदेश" },
        thankYou: { en: "Thank you! We have received your message.", mr: "धन्यवाद! आपला संदेश आम्हाला मिळाला आहे." },
        error: { en: "Something went wrong. Please try again or call us.", mr: "काहीतरी चूक झाली. कृपया पुन्हा प्रयत्न करा किंवा फोन करा." },
        required: { en: "Required", mr: "आवश्यक" },
        namePlaceholder: { en: "Enter your full name", mr: "तुमचे पूर्ण नाव टाका" },
        mobilePlaceholder: { en: "Enter your 10-digit mobile number", mr: "तुमचा १० अंकी मोबाईल नंबर टाका" },
        emailPlaceholder: { en: "Enter your email address", mr: "तुमचा ईमेल पत्ता टाका" },
        addressPlaceholder: { en: "Enter your residential address", mr: "तुमचा राहण्याचा पत्ता टाका" },
        messagePlaceholder: { en: "Tell us how we can help you...", mr: "आम्ही तुम्हाला कशी मदत करू शकतो ते सांगा..." }
    },

    footer: {
        quickLinks: { en: "Quick Links", mr: "महत्त्वाच्या लिंक्स" },
        services: { en: "Services", mr: "सेवा" },
        reach: { en: "Reach Us", mr: "संपर्क" },
        rights: { en: "All rights reserved.", mr: "सर्व हक्क राखीव." }
    },

    marquee: {
        items: {
            en: ["Attractive interest rates", "Fast loan processing", "Trusted service since 1996", "Call: 9987070049"],
            mr: ["आकर्षक व्याजदर", "जलद कर्ज प्रक्रिया", "१९९६ पासून विश्वासार्ह सेवा", "संपर्क: ९९८७०७००४९"]
        }
    },

    whyChoose: [
        { icon: "fa-shield-halved", title: { en: "Safe & Secure", mr: "सुरक्षित व विश्वासार्ह" }, desc: { en: "Regulated cooperative society with 28+ years of trust.", mr: "२८+ वर्षांचा विश्वास असलेली नियंत्रित सहकारी संस्था." } },
        { icon: "fa-bolt", title: { en: "Fast Processing", mr: "जलद प्रक्रिया" }, desc: { en: "Same-day decisions on most loan applications.", mr: "बहुतांश कर्ज अर्जांवर त्याच दिवशी निर्णय." } },
        { icon: "fa-handshake", title: { en: "Member-First", mr: "सभासद प्राधान्य" }, desc: { en: "Personalised service from people who know you.", mr: "तुमच्याशी ओळख असलेल्या व्यक्तींकडून वैयक्तिक सेवा." } },
        { icon: "fa-chart-line", title: { en: "Attractive Returns", mr: "आकर्षक परतावा" }, desc: { en: "Up to 10% PA on fixed deposits, plus senior citizen bonus.", mr: "मुदत ठेवीवर १०% पर्यंत व्याज, ज्येष्ठांसाठी अतिरिक्त लाभ." } },
        { icon: "fa-eye", title: { en: "Transparent", mr: "पारदर्शक" }, desc: { en: "Clear charges, no hidden fees, full disclosure.", mr: "स्पष्ट शुल्क, छुपे शुल्क नाही, संपूर्ण पारदर्शकता." } },
        { icon: "fa-people-group", title: { en: "Community-Driven", mr: "समाजकेंद्रित" }, desc: { en: "Profits reinvested for member and community benefit.", mr: "नफा सभासद व समाजाच्या हितासाठी पुनर्गुंतवला जातो." } }
    ],

    testimonials: [
        {
            quote: { en: "Sukhakarta has been my family's bank for over 15 years. Their loan processing is incredibly fast and the staff treats us like family.", mr: "सुखकर्ता पतपेढी ही माझ्या कुटुंबाची १५ वर्षांपासूनची बँक आहे. कर्ज प्रक्रिया अतिशय जलद आहे आणि कर्मचारी कुटुंबासारखे वागवतात." },
            name: { en: "Mr. Suresh Joshi", mr: "श्री. सुरेश जोशी" },
            role: { en: "Member since 2009 · Thane", mr: "२००९ पासून सभासद · ठाणे" }
        },
        {
            quote: { en: "The senior citizen FD rates are the best in our area. I have peace of mind knowing my retirement savings are secure here.", mr: "ज्येष्ठ नागरिकांसाठीचे एफडी दर आमच्या भागातील सर्वोत्तम आहेत. माझी निवृत्ती बचत येथे सुरक्षित आहे याची मला खात्री आहे." },
            name: { en: "Mrs. Vandana Kulkarni", mr: "सौ. वंदना कुलकर्णी" },
            role: { en: "Senior Member · Wagle Estate", mr: "ज्येष्ठ सभासद · वागळे इस्टेट" }
        },
        {
            quote: { en: "I got my business loan within 5 days. Their support helped my small shop grow into a thriving enterprise.", mr: "मला ५ दिवसांत व्यवसाय कर्ज मिळाले. त्यांच्या पाठिंब्यामुळे माझे छोटे दुकान आज भरभराटीचा व्यवसाय झाला आहे." },
            name: { en: "Mr. Rajesh Patil", mr: "श्री. राजेश पाटील" },
            role: { en: "Business Owner · Shreenagar", mr: "व्यावसायिक · श्रीनगर" }
        }
    ]
};
